import { createApp } from 'vue'
// import './assets/css/bootstrap.css'
// import './assets/css/barcode-generator.css'
import App from './App.vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { recaptcha_site_key } from "./constants/envrionment";

const app = createApp(App)

app.use(VueReCaptcha, {
    siteKey: recaptcha_site_key,
    loaderOptions: {
        explicitRenderParameters: {
            badge: 'bottomleft'
        }
    }
    
})

app.mount('#barcodeList')